import SensorOperationsView from "./SensorOperationsView"
import LayoutManagerView, { CustomButton } from "../LayoutManagerView"
import SiteView from "./SiteView"
import SiteTreeView from "./SiteTreeView"
import Graph2D from "@/Graph2D"
import DataStreamManagerObj from "./DataStreamManager"
import { SiteViewModel, SiteLoadResultViewModel, InfoViewModel, LocationViewModel, DeviceViewModel, PluginViewModel, MeshTransform, ElementViewModel, MeshRoot } from "../TemsManagerWebInterface"
import CalibrationAssistant from "./CalibrationAssistant";
import SiteWizardView from "./WizardView";
import { SiteState } from "@/TemsManagerWebEnums";
import { ViewModelUserLevel } from 'Tems/Security/TemsPolicy';
import Localization from "@/Localization";
import ManagerView from "@/ManagerView";
import TemsWebEvents from "@/TemsWebEvents";
import 'bootstrap';
import '@/jquery/x-editable';
import 'bootstrap-filestyle';
import THREE from "three";
const face = require("../ThreeFonts/optimer_regular.typeface");

export default class SiteManagerView extends LayoutManagerView {

    private site: SiteViewModel;

    public siteView = new SiteView(this); // NOTE: goal should be to have this thing private, but at the moment the code is still too tightly coupled
    public sensorOperationsView = new SensorOperationsView(this, $("#modalSensorConfigs"), $("#sensorOperations"));
    private expertModeActive: boolean;
    private openWizardOnSetupOpened: boolean;
    private siteTreeView: SiteTreeView;
    private profiles2DGraph: Graph2D;
    private dataStreamManager: DataStreamManagerObj;
    private calibrationAssistant: CalibrationAssistant;
    private hasSetupLock: boolean;
    private siteWizardView: SiteWizardView;
    private siteButtonUpdater: () => void = () => { };

    private selections: string[] = [];

    handleDocumentReady(): void {
        THREE.FontUtils.loadFace(face);
        super.handleDocumentReady();

        this.siteWizardView = new SiteWizardView(this);
        this.openWizardOnSetupOpened = false;

        let treeDomElem = $("#tableSiteTree");
        if (treeDomElem.length > 0) {
            this.siteTreeView = new SiteTreeView(this, treeDomElem);
        }
        const liveDataDomElem = $("#liveDataScatter");
        if (liveDataDomElem.length > 0) {
            this.profiles2DGraph = new Graph2D("#liveDataScatter");
            this.dataStreamManager = new DataStreamManagerObj(this, this.siteView, this.profiles2DGraph);
        }

        this.handleExpertModeChange(LayoutManagerView.GlobalSettings.Current.expertMode);

        $("body").removeClass("wizardEnabled");
        $("#badgeRestartIsInvalid").tooltip({ html: true });

        $("#buttonOpenModalLoadSite").click(() => {
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                $("#modalLoadSiteConfig").modal("show");
            });
        });

        $("#buttonStop").click(() => {
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                $.ajax({
                    url: "/api/SiteEdit/SiteStop",
                    method: "POST"
                }).done(() => {
                    this.showProcessingModal([SiteState.NotConfigured],
                        Localization.resourceStrings.SiteView_ModalStateChangeStoppingConfiguration,
                        Localization.resourceStrings.SiteView_ModalStateChangeStoppingConfiguration
                    );
                }).fail((data) => {
                    this.showAlertMessage(Localization.resourceStrings.SiteView_ModalAlertStoppingError, data.responseJSON.Message, Localization.resourceStrings.SiteView_ModalAlertErrorMessage);
                });
            });
        });

        $("#buttonRestart").click(() => {
            this.startSiteConfigHandler();
        });

        $("#buttonExpertMode").click(() => {
            this.handleExpertModeChange(!this.expertModeActive);
        });

        $("#buttonWizard,#buttonWizardDirect").click(() => {
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                if (!this.IsInEditMode) {
                    this.openWizardOnSetupOpened = true;
                    this.toggleEditMode();
                } else {
                    this.siteWizardView.startWizard();
                }
            });
        });

        $("#buttonEditModeDirect").click(() => {
            this.startEditModeHandler();
        });

        $("#buttonStartDirect").click(() => {
            this.startSiteConfigHandler();
        });

        $("#buttonModalLoadAndStartConfig").click(() => {
            var doneHandler = (data: SiteLoadResultViewModel, textStatus, jqXHR: JQueryXHR) => {
                $("#modalLoadSiteConfig").modal("hide");

                if (data.Message) {
                    this.showAlertMessage(Localization.resourceStrings.SiteView_ModalAlertLoadingError, data.Message, Localization.resourceStrings.SiteView_ModalAlertErrorMessage);
                } else {
                    // short waiting Time is needed in case the loading process is started in the desired state
                    setTimeout(() => { this.desiredStates = [SiteState.ConfigurationRunning, SiteState.ConfigurationRunningError]; }, 2000);
                    this.showProcessingModal([],
                        Localization.resourceStrings.SiteView_ModalStateChangeStartingConfiguration,
                        Localization.resourceStrings.SiteView_ModalStateChangeStartingConfiguration
                    );
                }
            };
            var failHandler = (jqXHR: JQueryXHR, status, error) => {
                this.showAlertMessage(Localization.resourceStrings.SiteView_ModalAlertLoadingError, error, Localization.resourceStrings.SiteView_ModalAlertErrorMessage);
            };
            $("#inputSiteConfigLoadMode").val("start");
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                $("#formModalLoadConfig").unbind("submit");
                $("#formModalLoadConfig").submit(this.getSiteConfigLoadHandler(doneHandler, failHandler));
                $("#formModalLoadConfig").submit();
            });
        });

        $("#buttonModalLoadAndEditConfig").click(() => {
            if (this.IsInEditMode) {
                var doneHandler = (data: SiteLoadResultViewModel, textStatus, jqXHR: JQueryXHR) => {
                    $("#modalLoadSiteConfig").modal("hide");
                    // new site information is aquired in handleUpdateSite process
                    // maybe request siteInfo outsite update cycle? May improve user Exp
                    if (data.Message) {
                        this.showAlertMessage(Localization.resourceStrings.SiteView_ModalAlertLoadingError, data.Message, Localization.resourceStrings.SiteView_ModalAlertErrorMessage);
                    }
                };
                var failHandler = (jqXHR: JQueryXHR, status, error) => {
                    this.showAlertMessage(Localization.resourceStrings.SiteView_ModalAlertLoadingError, error, Localization.resourceStrings.SiteView_ModalAlertErrorMessage);
                };
                $("#inputSiteConfigLoadMode").val("edit");
                this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                    $("#formModalLoadConfig").unbind("submit");
                    $("#formModalLoadConfig").submit(this.getSiteConfigLoadHandler(doneHandler, failHandler));
                    $("#formModalLoadConfig").submit();
                });
            }
        });

        $("#buttonEditSite").click(() => {
            this.startEditModeHandler();
        });

        $("#modalChooseStopStrategyKeepChanges").on("click", () => this.stopSiteConfigHandler("ExitSetupMode"));
        $("#modalChooseStopStrategyDiscardChanges").on("click", () => this.stopSiteConfigHandler("ExitSetupModeDiscardChanges"));

        $("#buttonResetSetup").click(() => {
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                var textBody = Localization.resourceStrings.SiteView_ResetConfigAcknText;
                var textTitle = Localization.resourceStrings.SiteView_ResetConfigAcknTitle;
                var buttonReset = CustomButton.Create(
                    Localization.resourceStrings.SiteView_ResetConfigAcknButtonReset,
                    () => {
                        if (this.siteTreeView) {
                            this.siteTreeView.resetSetupSiteConfig();
                        }
                        this.hideAcknowledgementModal();
                    },
                    true
                );
                this.showAcknowledgementModal(textBody, textTitle, buttonReset);
            });
        });

        $("#buttonStartCalibrationAssistant")
            .click(() => {
                if (this.calibrationAssistant && this.calibrationAssistant.IsRunning) {
                    this.stopCalibrate();
                } else {
                    this.startCalibrate();
                }
            });

        $("#buttonStartDeviceDiscovery").click(() => {
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                this.sensorOperationsView.startSensorDiscovery();
            });
        });

        $("#buttonModalSensorConfigsClose").click(() => {
            this.sensorOperationsView.closeSensorConfigDiscovery();
            setTimeout(() => { $("#modalSensorConfigs").modal("hide"); }, 300);  // Timeout because the transition looks aweful without it                
        });

        $("#titleSite").editable({
            disabled: 'true',
            success: (response, newValue) => {
                if (this.site && this.site.Id) {
                    this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                        var elementDetails = {
                            ElementId: this.site.Id,
                            Name: newValue
                        };

                        $.ajax({
                            url: "/api/SiteEdit/SaveElementDetailChanges",
                            type: "POST",
                            data: elementDetails,
                        }).done(() => {
                            this.forceSiteModelUpdate();
                        }).fail((err) => {
                            this.showAlertMessage(Localization.resourceStrings.SiteView_ErrorChangeSiteTitle.replace("{0}", elementDetails.Name), err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                            this.forceSiteModelUpdate();
                        });
                    });
                }
            }
        });

        $("#formSaveSite").on("submit", (event) => {
            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                $("#formSaveSite").unbind("submit");
                $("#formSaveSite").submit();
            });
            event.preventDefault();
        });

        $("#modalElementDetails").keypress(evt => {
            switch (evt.keyCode) {
                case 13: // Enter
                    if ($("#modalElementDetails").find(".editable-container").length === 0) {
                        $("#modalButtonSaveElementDetailChanges").click();
                    }
                    break;
                default:
                    break;
            }
        });

        $("#modalElementDetails").on("shown.bs.modal", (event) => {
            if (this.IsInEditMode) {
                $("#modalElementDetails > .modal-dialog > .modal-content > .modal-header > .close").addClass("hidden");
                $("#modalElementDetails").modal(ManagerView.MODAL_SHOW_NO_BACKDROP);
            } else {
                $("#modalElementDetails").modal(ManagerView.MODAL_SHOW_BACKDROP);
                $("#modalElementDetails > .modal-dialog > .modal-content > .modal-header > .close").removeClass("hidden");
            }

            if (this.IsInEditMode && !$("#collapseParameter").hasClass("hidden")) {
                $("#collapseParameter").collapse("show");
            } else {
                $("#collapseGeneral").collapse("show");
            }
        });

        $("#modalLoadSiteConfig").on("hide.bs.modal", () => {
            (document.getElementById("formModalLoadConfig") as HTMLFormElement).reset();
        });

        $("#modalElementDetails").on("hide.bs.modal", () => {
            $(".panel-collapse.collapse").collapse("hide");
            $(".panel-collapse.collapse").removeClass("in");
            $(".btn.showElementDetails.active").removeClass("active");
        });

        $(".panel-collapse.collapse").on("hidden.bs.collapse", (event) => {
            $(event.currentTarget).siblings(".panel-heading").find(".collapseIcon").removeClass("glyphicon-chevron-down");
            $(event.currentTarget).siblings(".panel-heading").find(".collapseIcon").addClass("glyphicon-chevron-right");
        });

        $(".panel-collapse.collapse").on("shown.bs.collapse", (event) => {
            $(event.currentTarget).siblings(".panel-heading").find(".collapseIcon").removeClass("glyphicon-chevron-right");
            $(event.currentTarget).siblings(".panel-heading").find(".collapseIcon").addClass("glyphicon-chevron-down");
        });

        $("#liveDataScatter").on("resized", () => {
            this.profiles2DGraph.initScaleAndCenter(6);
        });

        $("#buttonDataPointsFrontView").click(() => this.setGraphFrontView());
        $("#buttonDataPointsSideView").click(() => this.setGraphSideView());
        $("#buttonDataPointsTopView").click(() => this.setGraphTopView());


        try {
            this.siteView.init($("#divScenery"), 480);
            $("#noticeWebGlSupport").hide();
            $("#divScenery").mousedown(() => this.siteView.saveCameraConfigInCookie(false));
            $("#divScenery").on("wheel", () => this.siteView.saveCameraConfigInCookie(true));
        } catch (err) {
            $("#noticeWebGlSupport").show();
        }

        this.calibrationAssistant = new CalibrationAssistant($("#calibrationAssistantDiv"), this.dataStreamManager, this);

        TemsWebEvents.subscribeEvent(TemsWebEvents.CalibratableDevicesFound, (evt, canCalibrate) => {
            $("#buttonStartCalibrationAssistant").toggle(canCalibrate && this.hasSetupLock);
        });

        TemsWebEvents.subscribeEvent(TemsWebEvents.CalibrationObjectChanged, () => {
            this.forceSiteModelAndViewUpdate();
        });
    }

    handleSiteUpdate(model: InfoViewModel) {
        super.handleSiteUpdate(model);

        if (model.Recorder && $("#buttonLogin").length != 0) {
            window.location.reload();
        }

        // Buttons
        if (model && model.RecorderState) {
            if (this.hasSetupLock === undefined || this.hasSetupLock !== model.RecorderState.HasSetupLock) {
                this.hasSetupLock = model.RecorderState.HasSetupLock;
                this.handleSiteStateChange(model.RecorderState.SiteState);
            }

            if (!this.IsInEditMode) {
                this.sensorOperationsView.createSensorOperationInfo(model.RecorderState.SensorOperationStates);
            }

            $("body").toggleClass("wizardEnabled", model.EnableWizard)

            $("#buttonRestart").prop('disabled', !model.SiteConfigIsValid);
            $("#buttonRestart").toggleClass('iconDisabled', !model.SiteConfigIsValid);
            $("#badgeRestartIsInvalid").toggle(!model.SiteConfigIsValid && (model.RecorderState.SiteState === SiteState.NotConfigured || this.hasSetupLock));
            $("#noticeSiteNotConfigured").toggleClass("invalidConfig", !model.SiteConfigIsValid);

            if (model.RecorderState.SensorOperationStates.length > 0) {
                $("#sensorOperations").show();
            } else {
                $("#sensorOperations").hide();
            }
        } else {
            $("#noticeSiteNotConfigured").hide();
        }

        if (model && model.Site) {
            this.updateSite(model.Site);

            if (!this.IsInEditMode) {
                this.siteView.updateLatestResults(model.LatestResultIds);
            }
        } else {
            this.siteView.setScene(null);
            this.updateSite(null);
        }
    }

    protected handleSiteStateChange(newSiteState: SiteState) {
        super.handleSiteStateChange(newSiteState);

        
        $("#noticeSiteLoading").hide();

        (this.siteButtonUpdater = () => {
            const ownSetup = (newSiteState === SiteState.ConfigurationSetupActive && this.hasSetupLock);
            const idle = newSiteState === SiteState.NotConfigured;
            const idleOrSetup = idle || ownSetup;

            // Buttons are initially hidden and should show up with other buttons when state is known
            $("#buttonOpenModalLoadSite").show();
            $("#buttonEditSite").show();
            $("#buttonExpertMode").show();

            $("#buttonEditSite").toggle(newSiteState !== SiteState.ConfigurationSetupActive || this.hasSetupLock);
            $("#buttonExpertMode").toggleClass("active", this.expertModeActive);
            $("#buttonSave").toggle(!idle);
            $("#buttonWizard").toggle(!this.expertModeActive && idleOrSetup);
            $("#buttonStop").toggle(!(idle || ownSetup));
            $("#buttonRestart").toggle(ownSetup || idle);
        })();

        switch (newSiteState) {
            case SiteState.NotConfigured:
                $("#noticeSiteNotConfigured").show();
                $("#noticeOtherUserInSetup").hide();
                this.switchEditMode(false);
                break;
            case SiteState.ConfigurationSetupActive:
                $("#noticeSiteNotConfigured").hide();
                $("#noticeOtherUserInSetup").toggle(!this.hasSetupLock);
                if (this.openWizardOnSetupOpened) {
                    this.openWizardOnSetupOpened = false;
                    this.siteWizardView.startWizard();
                }
                this.switchEditMode(this.hasSetupLock);
                break;
            default:
                $("#noticeOtherUserInSetup").hide();
                $("#noticeSiteNotConfigured").hide();
                this.switchEditMode(false);
        }
    }

    public getPathById(id: string): string {
        var path = this.getByIdRoad(this.site.Locations, id);

        if (path === null) {
            path = this.getByIdPlugin(this.site.Plugins, id);
        }

        return path;
    }

    private getByIdRoad(roads: LocationViewModel[], id: string): string {
        let result = null;
        $.each(roads, (index, road) => {
            var roadName = road.Title;

            if (road.Id === id) {
                result = roadName;
                return false;
            } else {
                var devicePath = this.getByIdDevice(road.Devices, id);
                if (devicePath !== null) {
                    result = `${roadName} >> ${devicePath}`;
                    return false;
                }
            }
        });

        return result;
    }

    private getByIdDevice(devices: DeviceViewModel[], id: string): string {
        let result = null;
        $.each(devices, (index, device) => {
            var deviceName = device.Title;

            if (device.Id === id) {
                result = deviceName;
                return false;
            } else {
                var devicePath = this.getByIdDevice(device.Devices, id);
                if (devicePath !== null) {
                    result = `${deviceName} >> ${devicePath}`;
                    return false;
                }
            }
        });

        return result;
    }

    private getByIdPlugin(plugins: PluginViewModel[], id: string): string {
        let result = null;
        $.each(plugins, (index, plugin) => {
            var pluginName = plugin.Title;

            if (plugin.Id === id) {
                result = pluginName;
                return false;
            }
        });

        return result;
    }

    public get IsInEditMode(): boolean {
        return this.siteView.IsInEditMode;
    }

    private switchEditMode(enableEditMode): void {
        // Do we need to switch?
        if (enableEditMode === this.IsInEditMode) {
            return;
        }

        if (enableEditMode) {
            $("body").addClass("editMode");
            $(".editControl").slideDown();
            $(".element-state").hide();
            $(".siteEditable").editable('enable');
            $(".siteTreeSlider").slider('enable');
            $("#tableSiteTree").html("");
            $("#sitetree-pluginRootElement").show();

            $("#buttonEditSite").addClass("active");
            this.siteView.IsInEditMode = true;
        } else {
            $("body").removeClass("editMode");
            $(".editControl").slideUp();
            $(".element-state").show();
            $(".siteEditable").editable('disable');
            $(".siteTreeSlider").slider('disable');
            $("#sitetree-pluginRootElement").toggle($("#sitetree-pluginRootElement").find("li").length > 0);

            $("#buttonEditSite").removeClass("active");
            this.siteView.IsInEditMode = false;
        }
    }

    private toggleEditMode() {
        // This is only instructing the Server to enable setup mode. The UI transform will happen on the next update-cycle
        if (!this.IsInEditMode) {
            // overall:
            //    if config is stopped -> who is editing? 
            //       InfoViewModel, 'you're editing' --> UI is usable
            //                      'someone else is editing' --> Hide edit button, - unlock function? kick the other user out of the edit mode and discard his changes?
            //                      Do we actually need this? multi-user editing?... all parties should get updates in the periodic InfoViewModel.
            //
            // site is not in setup yet -> stop, enter setup. wait for infoviewmodel to tell us we're in setup...
            this.showProcessingModal([SiteState.ConfigurationSetupActive], Localization.resourceStrings.SiteView_TitleEnableEditMode);
            $.ajax({
                url: "/api/SiteEdit/EnterSetupMode",
                method: "POST"
            }).done(() => {
                // The call to EnterSetupMode waits some time (2s) for the state change to happen in TEMS Recorder. 
                // An immediate update should therefore switch the UI to desired state
                this.forceSiteModelUpdate();
            }).fail(err => {
                this.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
            });
        } else {
            $("#modalChooseStopStrategy").modal("show");
        }
    }

    private handleExpertModeChange(expertModeActiveState: boolean) {
        this.expertModeActive = expertModeActiveState;
        LayoutManagerView.GlobalSettings.updateSettings(s => s.expertMode = expertModeActiveState);
        $("body").toggleClass("expertMode", expertModeActiveState);
        this.siteButtonUpdater();
    }

    private getSiteConfigLoadHandler(doneHandler: (data: SiteLoadResultViewModel, textStatus, jqXHR) => void, failHandler: (jqXHR, status, error) => void): (event: JQuery.SubmitEvent) => void {
        return (event: JQuery.SubmitEvent) => {
            $.ajax({
                url: $(event.currentTarget).attr("action"),
                type: 'POST',
                data: new FormData($(event.currentTarget).get(0) as HTMLFormElement),
                processData: false,
                contentType: false
            }).done(doneHandler).fail(failHandler);

            event.preventDefault();
        };
    };

    public changeSequenceNumber(elementId: string, oldIndex: number, newIndex: number) {
        $.ajax({
            url: "/api/SiteEdit/ChangeSequenceNumber",
            type: 'POST',
            data: {
                Id: elementId,
                OldIndex: oldIndex,
                NewIndex: newIndex
            },
            dataType: 'json',
            mimeType: 'application/octet-stream'
        }).done(() => {
        }).fail((err) => {
        });
    }

    public setGraphFrontView() {
        $("#buttonDataPointsFrontView").addClass("active");
        $("#buttonDataPointsSideView").removeClass("active");
        $("#buttonDataPointsTopView").removeClass("active");
        this.profiles2DGraph.setXY();
        this.profiles2DGraph.setLabels("x", "y");
    }

    public setGraphSideView() {
        $("#buttonDataPointsSideView").addClass("active");
        $("#buttonDataPointsFrontView").removeClass("active");
        $("#buttonDataPointsTopView").removeClass("active");
        this.profiles2DGraph.setZY();
        this.profiles2DGraph.setLabels("z", "y");
    }

    public setGraphTopView() {
        $("#buttonDataPointsTopView").addClass("active");
        $("#buttonDataPointsFrontView").removeClass("active");
        $("#buttonDataPointsSideView").removeClass("active");
        this.profiles2DGraph.setZX();
        this.profiles2DGraph.setLabels("z", "x");
    }

    public forceSiteModelAndViewUpdate() {
        this.forceSiteModelUpdate();

        // NOTE This is still not the target solution
        // updateSite should notice itself that the view needs to be updated!
        this.siteView.requestSiteScene();
    }

    public stopCalibrate(): void {
        if (this.calibrationAssistant) {
            this.calibrationAssistant.close();
        }
        $("#buttonStartCalibrationAssistant").toggleClass("active", false);
    }

    public startCalibrate(): void {
        this.stopCalibrate();
        this.calibrationAssistant.show();
        $("#buttonStartCalibrationAssistant").toggleClass("active", true);
    }

    /*
     * Copies health/state-information from the server to the local site and updates the visualization
     */
    public updateSite(serverSite: SiteViewModel): void {
        if (!this.site) {
            this.site = {};
        }
        if (!serverSite) {
            serverSite = {};
        }

        if (this.siteTreeView) {
            var siteTreeModelChanged = this.siteTreeView.updateSiteTree(serverSite, this.site);

            // what we actually want to know is if the SiteViewModel had any changes to last time, that affect the View
            if (siteTreeModelChanged) {
                this.siteView.requestSiteScene().done(
                    () => this.applySelections(false)
                );

                this.attachSaveHandlerToNewTreeElements();

                this.stopCalibrate();
                this.handleExpertModeChange(this.expertModeActive);
            }
        }
        this.applySelections(false);
        // Set site title
        if ($("#titleSite").css("display") !== "none" && !$("#titleSite").hasClass("editable-open")) {
            $("#titleSite").editable('setValue', serverSite.Title ? serverSite.Title : "");
        }

        this.site = serverSite;

        this.calibrationAssistant.notifyCalibratable();
    }

    public attachSaveHandlerToNewTreeElements() {
        var newElements = $(".siteEditable.newEditableElement");
        if (newElements.length > 0) {
            newElements.editable(this.IsInEditMode ? 'enable' : 'disable');
            newElements.each((index, elem) => {
                const domElem = $(elem);
                if (domElem.hasClass("element-title")) {
                    domElem.editable("option", {
                        success: (response, newValue) => {
                            this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                                $.ajax({
                                    url: "/api/SiteEdit/SaveElementDetailChanges",
                                    type: 'POST',
                                    data: {
                                        ElementId: domElem.data("id"),
                                        Name: newValue
                                    },
                                }).done(() => {
                                    this.forceSiteModelUpdate();
                                    if (domElem.data("affectssiteview")) {
                                        // NOTE the problem is that we've already set the value in the tree to the new one that we'll receive in the next update
                                        // ==> one way would be to have the 'original' value in a backing field and compare against those to decide on the 'siteChanged' return value of updateSiteTree
                                        this.siteView.requestSiteScene();
                                    }
                                }).fail((err) => {
                                    this.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                                    this.forceSiteModelUpdate();
                                });
                            });
                        }
                    });
                }
            });

            newElements.removeClass("newEditableElement");
        }
    }

    private objectConstructor = {}.constructor;
    private arrayConstructor = [].constructor;
    public getObjectFromSiteById(id: string, root: any = this.site): any {
        if (root.constructor === this.objectConstructor || root.constructor === this.arrayConstructor) {
            for (var prop in root) {
                if (root.hasOwnProperty(prop)) {
                    var obj = root[prop];
                    if (obj) {
                        if (obj.Id === id) {
                            return obj;
                        } else {
                            var subObj = this.getObjectFromSiteById(id, obj);
                            if (subObj) {
                                return subObj;
                            }
                        }
                    }
                }
            }
        }
    }

    public findRoadIdByDeviceId(deviceId: string): LocationViewModel {
        if (this.site) {
            for (var i = 0, roadsLen = this.site.Locations.length; i < roadsLen; i++) {
                let road = this.site.Locations[i];
                if (this.findDeviceById(deviceId, road.Devices) !== null) {
                    return road;
                }
            }
        }

        return null;
    }

    private findDeviceById(deviceId: string, devices: DeviceViewModel[]): DeviceViewModel {
        if (devices) {
            for (var i = 0, devLen = devices.length; i < devLen; i++) {
                let device = devices[i];
                if (device.Id === deviceId) {
                    return device;
                } else {
                    let subDevice = this.findDeviceById(deviceId, device.Devices);
                    if (subDevice !== null) {
                        return subDevice;
                    }
                }
            }
        }

        return null;
    }

    /*
     * Sets the selection-state of the element with the given "id" to TRUE and all others to FALSE
     */
    public selectElement(id: string) {
        // deselect first
        // Reason: 
        //   Let: device A with subdevice B, C
        //
        //   select B ==> B highlighted
        //   select A ==> A highlighted and B and C, so far so good
        //            ==> BUT! B then changes back to $Selected.No ==> Highlight removed..
        this.selections = [];
        this.applySelections(true);

        if (id && !this.isElementSelected(id)) {
            // Actual new selection
            this.selections = [id];
            this.applySelections(true);
            TemsWebEvents.publishEvent(TemsWebEvents.ElementSelected, [id]);
        }
    }

    private startSiteConfigHandler() {
        var startButton = $("#buttonRestart");

        if (startButton.prop("disabled")) {
            return;
        }

        startButton.prop("disabled", true);
        this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "/api/SiteEdit/SiteRestart",
                    method: "POST"
                }).done(() => {
                    this.showProcessingModal([SiteState.ConfigurationRunning, SiteState.ConfigurationRunningError],
                        Localization.resourceStrings.SiteView_ModalStateChangeStartingConfiguration,
                        Localization.resourceStrings.SiteView_ModalStateChangeStartingConfiguration
                    );
                    $(".showAllChildDevices").removeClass("showAllChildDevices");
                    resolve();
                }).fail((data) => {
                    this.showAlertMessage(
                        Localization.resourceStrings.SiteView_ModalAlertStartingError,
                        data.responseJSON.Message,
                        Localization.resourceStrings.SiteView_ModalAlertErrorMessage
                    );
                    reject();
                });
            });
        }).catch(() => { }).then(function () {
            // .then() after .catch() is similar to .finally() method, which doesn't exist yet (But will be introduced soon, 02/2018)
            startButton.prop("disabled", false);
        });
    }

    private stopSiteConfigHandler(endpoint: string) {
        this.showProcessingModal([SiteState.NotConfigured], Localization.resourceStrings.SiteView_TitleDisableEditMode);
        $.ajax({
            url: "/api/SiteEdit/" + endpoint,
            method: "POST"
        }).done(() => {
            // nothing to do the general update loop will handle the transition
        }).fail(err => {
            this.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
        });
    }

    private startEditModeHandler() {
        this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            this.toggleEditMode();
        });
    }

    public isElementSelected(id: string): boolean {
        return $.inArray(id, this.selections) !== -1;
    }

    private applySelections(updatePage: boolean) { // updatePage true means that other page elements should react to the change. (i.e. 3D should change some visibilities, tree should highlight stuff, etc.)
        var selectElement = (element: ElementViewModel) => {
            if (element.States) {
                const isSelected = this.isElementSelected(element.Id);
                this.applySelectedState(element, isSelected);

                this.siteView.displayElementState(element);

                if (this.siteTreeView) {
                    this.siteTreeView.displayElementState(element, isSelected);
                }
            }
        };

        var selectDevice = (device: DeviceViewModel) => {
            selectElement(device);

            for (let i = 0, devicesLength = device.Devices.length; i < devicesLength; i++) {
                var childDevice = device.Devices[i];
                selectDevice(childDevice);
            }
        };

        if (this.site.Locations) {
            for (var road of this.site.Locations) {
                selectElement(road);

                if (road.Devices) {
                    for (var device of road.Devices) {
                        selectDevice(device);
                    }
                }
            }
        }

        if (this.site.Plugins) {
            for (var plugin of this.site.Plugins) {
                selectElement(plugin);
            }
        }
    }

    /*
     * Adds either "$Selected.No" or "$Selected.Yes" to the "States" property (according to "doSelect" argument) and removes the other one.
     * Returns true, if the list was changed.
     */
    private applySelectedState(element: ElementViewModel, doSelect: boolean) {
        var wasChanged = false;
        if (element.States !== null) {
            var noIdx = $.inArray("$Selected.No", element.States);
            if (noIdx >= 0) {
                if (doSelect) {
                    element.States.splice(noIdx, 1);
                    wasChanged = true;
                }
            } else if (!doSelect) {
                element.States.push("$Selected.No");
                wasChanged = true;
            }

            var yesIdx = $.inArray("$Selected.Yes", element.States);
            if (yesIdx >= 0) {
                if (!doSelect) {
                    element.States.splice(yesIdx, 1);
                    wasChanged = true;
                }
            } else if (doSelect) {
                element.States.push("$Selected.Yes");
                wasChanged = true;
            }
        }

        if (this.calibrationAssistant.IsCalibratable) {
            element.States.push("Calibrating" + this.calibrationAssistant.roadModelId);
        }

        return wasChanged;
    }
}